import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@chama/ui-components/components/Modal';
import DealersNearbyList from './DealersNearbyList';

const propTypes = {
  nearbyDealersList: PropTypes.array.isRequired,
  formatMessage: PropTypes.func.isRequired,
  onTakeOverConfirm: PropTypes.func.isRequired,
  handleRef: PropTypes.func.isRequired,
  dealer: PropTypes.object.isRequired,
};

const MdtModals = props => {
  const { handleRef, formatMessage, dealer, nearbyDealersList, onTakeOverConfirm } = props;

  return (
    <span>
      <Modal
        ref={handleRef('reallocationModal')}
        size="large"
        title={formatMessage({
          id: 'dealers_nearby_order_address',
          defaultMessage: 'Dealer nearby order address',
        })}
        confirmButtonText={formatMessage({
          id: 'closeLabel',
          defaultMessage: 'Close',
        })}
      >
        <DealersNearbyList currentDealer={dealer} dealerList={nearbyDealersList} />
      </Modal>

      <Modal
        ref={handleRef('takeControlModal')}
        title={formatMessage({
          id: 'you_are_about_to_control_this_order',
          defaultMessage: 'You are about to control this order',
        })}
        cancelButtonText={formatMessage({
          id: 'general.cancel',
          defaultMessage: 'Cancel',
        })}
        confirmButtonText={formatMessage({
          id: 'proceed',
          defaultMessage: 'Proceed',
        })}
        onConfirm={onTakeOverConfirm}
      >
        <React.Fragment>
          {formatMessage({
            id: 'take_control_modal_body_text1',
            defaultMessage:
              'By taking over this order, only Chama will be able to take actions on this order until un-assigned again',
          })}
        </React.Fragment>
        <br />
        <React.Fragment>
          {formatMessage({
            id: 'take_control_modal_body_text2',
            defaultMessage:
              "All actions taken upon this will reflect int the dealer's Dealer Tool, Chama system and the app.",
          })}
        </React.Fragment>
      </Modal>
    </span>
  );
};

MdtModals.propTypes = propTypes;

export default MdtModals;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/MdtModals.jsx